<template>
    <div class="table-responsive">
        <table class="subscriptions-table table mt-3" style="width: 100%;">
            <tbody>
                <tr>
                    <th style="border: 0 black solid;" scope="col"></th>
                    <th class="planTableHeader" scope="col">Verify Artworks with Image</th>
                    <th class="planTableHeader" scope="col">Event Notifications Monthly</th>
                    <th class="planTableHeader" scope="col">Users Reached Per Notification</th>
                    <th class="planTableHeader" scope="col">Manage Artworks</th>
                    <th class="planTableHeader" scope="col">Add Events</th>
                    <th class="planTableHeader" scope="col">View Reports</th>
                </tr>
                <tr>
                    <th class="planTableSide" scope="row">Bronze Curator</th>
                    <td>25</td>
                    <td>1</td>
                    <td>Up to 2,000</td>
                    <td>Unlimited</td>
                    <td>Unlimited</td>
                    <td>Unlimited</td>
                </tr>
                <tr>
                    <th class="planTableSide" scope="row">Silver Curator</th>
                    <td>80</td>
                    <td>3</td>
                    <td>Up to 5,000</td>
                    <td>Unlimited</td>
                    <td>Unlimited</td>
                    <td>Unlimited</td>
                </tr>
                <tr>
                    <th class="planTableSide" scope="row">Gold Curator</th>
                    <td>250</td>
                    <td>6</td>
                    <td>Up to 10,000</td>
                    <td>Unlimited</td>
                    <td>Unlimited</td>
                    <td>Unlimited</td>
                </tr>
                <tr>
                    <th class="planTableSide" scope="row">Platinum Curator</th>
                    <td>Customizable</td>
                    <td>Customizable</td>
                    <td>Customizable</td>
                    <td>Unlimited</td>
                    <td>Unlimited</td>
                    <td>Unlimited</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'SubscriptionDetailsGrid',
    }
</script>